import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import MenuSiderSearch from '../components/Web/MenuSiderSearch';
import MainBanner from '../components/Web/MainBanner';
import { getSearchCategoriesApi } from '../api/search';

import '../assets/css/main.css';

export default function LayoutBasic(props) {
    const { routes, location, history } = props;
    const [ categories, setCategories ] = useState("");
    const [ reloadCategories, setReloadCategories ] = useState(false);

    useEffect(() => {
        getSearchCategoriesApi().then(response => {
          setCategories(response.resultado);
        });

        setReloadCategories(false);
    }, [reloadCategories]);


    if (location.pathname === '/') {
      // Home
      return (
        <div>
          <MainBanner 
            location={location} 
            setReloadCategories={setReloadCategories}
          />
          <div className="container-fluid bg-white" style={{"color":"black"}}>
            <LoadRoutes 
              routes={routes} 
            />
          </div>
        </div>
      )
    } else {
      if ( location.pathname.lastIndexOf("/termsandconditions", 0) === 0 || location.pathname.lastIndexOf("/support", 0) === 0 ) {
        return (
          <div className="container-fluid" >
              <LoadRoutes 
                routes={routes}
              />
            </div>
        )
      } else {
        return (
          <div>
            <MainBanner 
              location={location}
              setReloadCategories={setReloadCategories}
            />
            <div className="container-fluid" style={{"paddingLeft":"9px", "color":"black"}}>
              <div className="row flex-xl-nowrap">
                <MenuSiderSearch
                  categories={categories}
                  setCategories={setCategories}
                  location={location}
                  history={history}
                  setReloadCategories={setReloadCategories}
                />
                <div className="col-md-10 bg-white">
                  <div className="container-fluid" >
                    <LoadRoutes
                      routes={routes} 
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    }
    
}

function LoadRoutes({ routes }){
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route 
          key={index}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ))}
    </Switch>
  );
}